/**
 * @generated SignedSource<<cc7770e3fb2fd979845343325dfb00a2>>
 * @relayHash 512d3c288e476ca23b45061d9102b2d6
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID e2afb2ac9c484784fd55eb2fcafbcb54d438eef15f40b0e4c160a6b625de2a3b

import type { ConcreteRequest } from 'relay-runtime';
export type usePageTitlePageTitleQuery$variables = {
  contentId: string;
};
export type usePageTitlePageTitleQuery$data = {
  readonly singleContent: {
    readonly id: string | null;
    readonly title: string | null;
  } | null;
};
export type usePageTitlePageTitleQuery = {
  response: usePageTitlePageTitleQuery$data;
  variables: usePageTitlePageTitleQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "contentId"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "contentId"
      }
    ],
    "concreteType": "Content",
    "kind": "LinkedField",
    "name": "singleContent",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "id"
      },
      {
        "kind": "ScalarField",
        "name": "title"
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "usePageTitlePageTitleQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "usePageTitlePageTitleQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "512d3c288e476ca23b45061d9102b2d6",
    "id": "e2afb2ac9c484784fd55eb2fcafbcb54d438eef15f40b0e4c160a6b625de2a3b",
    "metadata": {},
    "name": "usePageTitlePageTitleQuery",
    "operationKind": "query",
    "text": "query usePageTitlePageTitleQuery($contentId:ID!){singleContent(id:$contentId){id,title}}"
  }
};
})();

(node as any).hash = "49163e20c25d3da0c01ad2e924f87c37";

export default node;
